// 获取首页数据
export const Get_IndexData = state => {
  return state.IndexData
}

// 获取首页分类数据
export const Get_Cate_list = state => {
  // console.log(state.IndexData.cate_list)
  return state.IndexData.cate_list
}

// // 获取首页分类数据
export const Get_Token = state => {
  return state.token
}





// WEBPACK FOOTER //
// ./src/store/getters.js